import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence, enableNetwork } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';

// Your Firebase configuration
// Replace with your actual Firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyDc-DNrR2ewJMC2qs6eEOTWjQRItSKSaQo",
  authDomain: "mahstry.firebaseapp.com",
  projectId: "mahstry",
  storageBucket: "mahstry.firebasestorage.app",
  messagingSenderId: "519252445399",
  appId: "1:519252445399:web:14701d970f27b16fd30892",
  measurementId: "G-PP9TYBYFQK",
  // Realtime Database URL - Get this from Firebase Console > Realtime Database
  // Format: https://PROJECT_ID-default-rtdb.REGION.firebasedatabase.app
  // Or: https://PROJECT_ID.firebaseio.com (legacy)
  // IMPORTANT: If you see a sign-in page, the database is NOT created yet!
  // Go to Firebase Console > Realtime Database > Create Database
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://mahstry-default-rtdb.firebaseio.com"
};

// Initialize Firebase with performance optimizations
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
// Messaging is only available in supported environments (browsers with Notifications/Service Worker)
export const messagingPromise = isSupported()
  .then(() => getMessaging(app))
  .catch(() => null);
// Initialize Realtime Database
let realtimeDb;
try {
  realtimeDb = getDatabase(app);
  console.log('Realtime Database initialized successfully');
  console.log('Database URL:', firebaseConfig.databaseURL);
} catch (error) {
  console.error('Error initializing Realtime Database:', error);
  console.error('Make sure databaseURL is correct in firebaseConfig');
  console.error('Current databaseURL:', firebaseConfig.databaseURL);
  // Still export it so the app doesn't crash, but it will fail when used
  realtimeDb = null;
}

export { realtimeDb };

// Performance optimizations
let persistenceEnabled = false;

// Enable offline persistence for better performance and offline support
const enablePersistence = async () => {
  if (persistenceEnabled) return;
  
  try {
    await enableIndexedDbPersistence(db, {
      synchronizeTabs: true
    });
    persistenceEnabled = true;
    } catch (err) {
    if (err.code === 'failed-precondition') {
      } else if (err.code === 'unimplemented') {
      } else {
      }
  }
};

// Enable persistence on initialization
enablePersistence();

// Performance monitoring
export const performanceMonitor = {
  startTime: null,
  measurements: new Map(),
  
  start(operation) {
    this.startTime = performance.now();
    this.measurements.set(operation, { start: this.startTime });
  },
  
  end(operation) {
    if (!this.startTime) return;
    
    const endTime = performance.now();
    const duration = endTime - this.startTime;
    
    const measurement = this.measurements.get(operation) || {};
    measurement.end = endTime;
    measurement.duration = duration;
    measurement.count = (measurement.count || 0) + 1;
    measurement.average = measurement.count > 1 
      ? ((measurement.average || 0) * (measurement.count - 1) + duration) / measurement.count
      : duration;
    
    this.measurements.set(operation, measurement);
    
    // Log slow operations
    if (duration > 1000) {
    }
    
    return duration;
  },
  
  getStats() {
    const stats = {};
    this.measurements.forEach((measurement, operation) => {
      stats[operation] = {
        count: measurement.count,
        average: measurement.average,
        lastDuration: measurement.duration
      };
    });
    return stats;
  }
};

// Connection optimization
export const optimizeConnection = async () => {
  try {
    // Enable network connection for real-time updates
    await enableNetwork(db);
    } catch (error) {
    }
};

// Initialize connection optimization
optimizeConnection();

// Memory usage monitoring
export const getMemoryUsage = () => {
  if ('memory' in performance) {
    return {
      used: performance.memory.usedJSHeapSize,
      total: performance.memory.totalJSHeapSize,
      limit: performance.memory.jsHeapSizeLimit
    };
  }
  return null;
};

// Development mode emulator connections (only in development)
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectDatabaseEmulator(realtimeDb, 'localhost', 9000);
    } catch (error) {
    }
}

export default app;
